define('views/app/base-layout',[
    // Libs
    'underscore', 'backbone', 'utils', 'bootbox',
    // services
    'services/app-state',
    'services/session',
    'services/events/conversation-events',
    'services/events/user-events',
    'services/user',
    'services/i18n',
    'services/platform.service',
    // Models
    'collections/member/groups',
    'collections/conversation/conversations',
    'collections/onboarding/tutorials',
    'models/member/group',
    'models/member/profile',
    // layouts
    'views/layouts/layout-app',
    // views
    'views/modules/help/help-panel'
], function(
    // Libs
    _, Backbone, U, Bootbox,
    // services
    AppState, Session, ConversationEvents, UserEvents, User, i18n, PlatformService,
    // Models
    CGroups,
    CConversations,
    COnboardingTutorials,
    MGroup,
    MProfile,
    // Layouts
    VLayoutApp,
    // views
    VHelpPanel
) {

    var VBaseLayout = VLayoutApp.extend({
        menu: {
            profile: _.noop,
            primary: _.noop,
            secondary: _.noop
        },

        constructor: function(options) {
            this.url = options.url;
            this.role = options.role;

            var group = this.group = {
                    list: new CGroups(null, { tree: false, removeExpired: true }),
                    current: new MGroup(),
                },
                profile = this.profile = new MProfile(),
                newConversations = this.newConversations = new CConversations(),
                menu = this.menu;

            _.extend(options, { group: this.getGroup() });
            VBaseLayout.__super__.constructor.call(this, options);

            this.getMenu()
                .setProfileItems(menu.profile.call(this))
                .setPrimary(menu.primary.call(this));

            if (User.has('backgroundColor')) {
                this.setBrandColor();
            }

            profile.setId('me');

            this.listenTo(User, 'sync', this.onUserSync)
                .listenTo(group.current, 'sync', this.onCurrentGroupSync)
                .listenTo(newConversations, 'sync', this.onNewConversationsSync)
                .listenTo(COnboardingTutorials, 'sync', this.onOnboardingTutorialsSync)
                .listenTo(UserEvents, 'refreshCompletedTutorialsCount', this.setRemainingTutorialsCount);

            this.initListener();
        },

        initListener: function() {
            this.stopListeningTo(ConversationEvents);
            this.listenTo(ConversationEvents, { 'conversation:click': this.onConversationClick })
                .listenTo(ConversationEvents, { 'conversation:markAllAsRead': this.onMarkAllAsRead })
                .listenTo(ConversationEvents, { 'stack:showQuestionnaireResponse': this.onShowQuestionnaireResponse })
                .listenTo(ConversationEvents, { 'markedAsReadOrUnread': this.markedAsReadOrUnread });

            return this;
        },

        getUnreadConversations: function() {
            this.newConversations.getFirstPage({ unread: true });
            return this;
        },

        /**
         * Sets the supervised group id.
         * @param {string} id of the group
         * @return {Promise}
         */
        setGroupId: function(id, opt) {
            opt = opt || {};
            if (!id) throw new Error("An invalid group id was provided. id = " + id);
            var current = this.getGroup();
            if (current.id !== id) {
                current.setId(id);
                return current.fetch(_.extend({ reset: true }, opt));
            }
            return Backbone.$.Deferred().resolveWith(opt.context || this).promise();
        },

        setMemberId: function(id, opt) {
            opt = opt || {};
            if (!id) throw new Error("An invalid member id was provided. id = " + id);
            var profile = this.getMember();
            if (profile.id !== id || !profile.isReady()) {
                profile.setId(id);
                if (opt.group) profile.setGroup(opt.group);
                return profile.fetch(_.extend({ reset: true }, opt));
            }
            return Backbone.$.Deferred().resolveWith(opt.context || this).promise();
        },

        getGroup: function() {
            return this.group.current;
        },

        getMember: function() {
            return this.profile;
        },

        updateProfileMenu: function() {
            var profileMenu = this.getMenu().getProfile();
            var primaryMenu = this.getMenu().getPrimary();

            if (User.isAdmin()) {
                profileMenu.addItem({
                    content: 'Admin',
                    route: window.env.OLD_ORIGIN + 'admin/',
                    icon: 'sl-icon-settings',
                    id: 'admin',
                    target: '_blank',
                    external: true
                });
            } else {
                profileMenu.removeItem('admin');
            }

            if (PlatformService.isNative() || AppState.onClientSide()) {
                primaryMenu.removeItem('onboarding');
            }

            if (User.id && !User.get('showOnboarding')) {
                primaryMenu.removeItem('onboarding');
            }
        },

        setBrandColor: function() {
            AppState.setBrandColor(User.getBrandColor());
            return this;
        },

        setMenuDrawerContent: function(view, open) {
            VBaseLayout.__super__.setMenuDrawerContent.call(this, view, open);
        },

        setRemainingTutorialsCount: function() {
            var onboardingMenuItem = this.getMenu().getPrimary().findItem('onboarding');

            if (onboardingMenuItem) {
                var remaining = COnboardingTutorials.models.length - User.get('completedTutorials').length;
                onboardingMenuItem.set('badge', remaining > 0 ? remaining : null);
            }
        },

        //////////
        // menu //
        //////////

        showHelpMenu: function() {
            var view = this.view.help;
            if (!view) {
                this.view.help = view = new VHelpPanel({
                    model: this.profile,
                    group: this.getGroup(),
                    url: this.url,
                    role: this.role,
                });
            }
            this.setMenuDrawerContent(view);
        },

        /////////////
        // actions //
        /////////////

        onLogoutAction: function(e, item, menu) {
            Session.signOut();
        },

        ////////////
        // events //
        ////////////
        onCurrentGroupSync: function(model) {
            var profileMenu = this.getMenu().getProfile();

            if (!model.isSupervisor()) {
                profileMenu.removeItem('layoutSwitch');
            }
        },

        onUserSync: function(model) {
            this.setBrandColor()
                .updateProfileMenu();

            this.setRemainingTutorialsCount();
        },

        onNewConversationsSync: function(collection) {
            var primaryMenu = this.getMenu().getPrimary(),
                messageItem = primaryMenu.findItem('message');
            messageItem.set('badge', collection.getTotal());
        },

        onConversationClick: function(model) {
            var primaryMenu = this.getMenu().getPrimary(),
                messageItem = primaryMenu.findItem('message'),
                newConversations = this.newConversations;

            if (newConversations.get(model)) {
                var nbrUnread = Number(messageItem.get('badge') - 1);
                if (nbrUnread < 0) nbrUnread = 0;
                messageItem.set('badge', nbrUnread || null);
            }
        },

        onMarkAllAsRead: function() {
            var primaryMenu = this.getMenu().getPrimary(),
                messageItem = primaryMenu.findItem('message');

            messageItem.set('badge', null);
        },

        onShowQuestionnaireResponse: function(panel) {
            this.setMenuDrawerContent(panel);
        },

        onDisable: function() {
            this.stopListeningTo(ConversationEvents);
        },

        onOnboardingTutorialsSync: function() {
            if (User.get('showOnboarding') && PlatformService.isWeb()) {
                this.setRemainingTutorialsCount();
            }
        },

        markedAsReadOrUnread: function() {
            this.newConversations.getFirstPage({ unread: true });
        }
    });

    return VBaseLayout;

});

